export default __webpack_public_path__ + "static/media/testimonials-banner.5e9f25b2.webp";